import styled from "styled-components";
import { motion } from "framer-motion";
import { letterAnimate } from "../animation";

const Hero = () => {
  return (
    <Section>
      <Container>
        <motion.div
          className="bigScreen"
          initial={"hide"}
          animate={"show"}
          transition={{ delayChildren: 0.4, staggerChildren: 0.1 }}
        >
          <span>
            <motion.span variants={letterAnimate}>S</motion.span>
            <motion.span variants={letterAnimate}>O</motion.span>
            <motion.span variants={letterAnimate}>F</motion.span>
            <motion.span variants={letterAnimate}>T</motion.span>
          </span>
          <span>
            <motion.span variants={letterAnimate}>W</motion.span>
            <motion.span variants={letterAnimate}>A</motion.span>
            <motion.span variants={letterAnimate}>R</motion.span>
            <motion.span variants={letterAnimate}>E</motion.span>
          </span>
        </motion.div>
        <motion.div
          className="bigScreen"
          initial={"hide"}
          animate={"show"}
          transition={{ delayChildren: 1, staggerChildren: 0.1 }}
        >
          <motion.span variants={letterAnimate}>D</motion.span>
          <motion.span variants={letterAnimate}>E</motion.span>
          <motion.span variants={letterAnimate}>V</motion.span>
          <motion.span variants={letterAnimate}>E</motion.span>
          <motion.span variants={letterAnimate}>L</motion.span>
          <motion.span variants={letterAnimate}>O</motion.span>
          <motion.span variants={letterAnimate}>P</motion.span>
          <motion.span variants={letterAnimate}>E</motion.span>
          <motion.span variants={letterAnimate}>R</motion.span>
        </motion.div>

        <motion.div
          initial={"hide"}
          animate={"show"}
          transition={{ delayChildren: 0.4, staggerChildren: 0.1 }}
          className="smallScreen"
        >
          <motion.span variants={letterAnimate}>S</motion.span>
          <motion.span variants={letterAnimate}>O</motion.span>
          <motion.span variants={letterAnimate}>F</motion.span>
          <motion.span variants={letterAnimate}>T</motion.span>
        </motion.div>
        <motion.div
          initial={"hide"}
          animate={"show"}
          transition={{ delayChildren: 1, staggerChildren: 0.1 }}
          className="smallScreen"
        >
          <motion.span variants={letterAnimate}>W</motion.span>
          <motion.span variants={letterAnimate}>A</motion.span>
          <motion.span variants={letterAnimate}>R</motion.span>
          <motion.span variants={letterAnimate}>E</motion.span>
        </motion.div>
        <motion.div
          initial={"hide"}
          animate={"show"}
          transition={{ delayChildren: 1.8, staggerChildren: 0.1 }}
          className="smallScreen"
        >
          <motion.span variants={letterAnimate}>D</motion.span>
          <motion.span variants={letterAnimate}>E</motion.span>
          <motion.span variants={letterAnimate}>V</motion.span>
          <motion.span variants={letterAnimate}>E</motion.span>
          <motion.span variants={letterAnimate}>L</motion.span>
          <motion.span variants={letterAnimate}>O</motion.span>
          <motion.span variants={letterAnimate}>P</motion.span>
          <motion.span variants={letterAnimate}>E</motion.span>
          <motion.span variants={letterAnimate}>R</motion.span>
        </motion.div>
        <Scroll
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 4 }}
        >
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ ease: "easeInOut", duration: 1, delay: 4.5 }}
          >
            scroll
          </motion.p>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ ease: "easeInOut", duration: 1, delay: 4.5 }}
          >
            down
          </motion.p>
        </Scroll>
      </Container>
    </Section>
  );
};

const Section = styled.section`
  width: 100%;
  min-height: 50vh;
`;

const Container = styled(motion.div)`
  position: relative;
  width: 87%;
  margin: 0 auto;
  padding-top: 3rem;
  .bigScreen {
    width: max-content;
    margin: 0 auto;
  }
  .bigScreen,
  .smallScreen {
    overflow: hidden;
    span {
      display: inline-block;
      font-family: "Antonio", sans-serif;
      font-weight: 700;
      font-size: 17.8rem;
      line-height: 12rem;
      transition: color 0.3s linear;
      &:hover {
        color: #d6e5fa;
      }
    }
  }

  .smallScreen {
    display: none;
    text-align: center;
  }

  @media screen and (max-width: 75em) {
    .bigScreen {
      span {
        font-size: 16rem;
      }
    }
  }

  @media screen and (max-width: 64em) {
    .bigScreen {
      span {
        font-size: 14rem;
      }
    }
  }

  @media screen and (max-width: 56.25em) {
    .bigScreen {
      span {
        font-size: 12rem;
      }
    }
  }

  @media screen and (max-width: 51.25em) {
    .bigScreen {
      span {
        font-size: 11rem;
      }
    }
  }

  @media screen and (max-width: 48em) {
    .bigScreen {
      display: none;
    }
    .smallScreen {
      display: block;
      span {
        font-size: 9rem;
        line-height: 8rem;
      }
    }
  }

  @media screen and (max-width: 37.5em) {
    .smallScreen {
      display: block;
      span {
        font-size: 8rem;
        line-height: 8rem;
      }
    }
  }
`;

const Scroll = styled(motion.div)`
  font-size: 0.8rem;
  border: 2px solid #aaaaaa;
  line-height: 1rem;
  border-radius: 50%;
  width: max-content;
  padding: 1rem;
  margin-top: 3rem;
  position: absolute;
  left: 50%;
  bottom: -18%;
  transform: translateX(-50%);

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export default Hero;
